module.exports = __webpack_public_path__ + "static/media/pointing-right.3d581371.png";